
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationG as ObiLocationGElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-g.js';
 
 
 

 
 export const ObiLocationG = createComponent({
   react: React,
   tagName: 'obi-location-g',
   elementClass: ObiLocationGElement,
   events: {
     
   }
  });
 
 